import * as d3 from "d3";

const EventMouse = {
  mouseOver: function (node) {
    if(node.readOnly) return

    d3.selectAll(`#${node.idName} > .circle-hide`)
      .style('fill', 'rgba(255, 0, 0, 0.705)')
  },

  mouseOut: function (node){
    if(node.readOnly) return

    d3.selectAll(`#${node.idName} > .circle-hide`)
      .style('fill', '#0000')
  }
}

export default EventMouse